
<template>
    <div class="stepperButtonWrapper">
        <div class="title">{{title}}</div>
        <div class="stepperButton" @click="decreaseRatings()">-</div>
        <span class="rating">{{(starRating > 0 ? '+' : '')}}{{starRating}}</span>
        <div class="stepperButton" @click="increaseRatings()">+</div>
        <div class="confirmRatings" :class="diableRatings" @click="confirmRatings()">
        <span  v-tooltip="buttonText">{{starRatingsUpdated}}</span></div>
    </div>
</template>

<script>
// import { clearTimeout } from 'timers';
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
    },
    name: 'ratingInputTests',
    data () {
        return {
            starRating: 0,
            updated: false,
        };
    },
    computed: {
        diableRatings () {
            return this.starRating === 0 ? 'disabled' : '';
        },
        starRatingsUpdated () {
            return this.updated ? 'Updated' : 'Assign stars';
        },
        buttonText () {
            return this.starRating === 0 ? 'Use the plus and minus buttons to adjust the stars first' : `Assign ${this.starRating} stars to this test`;
        },
    },
    methods: {
        increaseRatings () {
            this.starRating < 9 ? ++this.starRating : '';
            this.$emit('rating', this.starRating);
        },
        decreaseRatings () {
            this.starRating > -9 ? --this.starRating : '';
            this.$emit('rating', this.starRating);
        },
        confirmRatings () {
            if (this.starRating !== 0) {
                this.$emit('currentRating', this.starRating);
                this.updated = !this.updated;
                setTimeout(() => {
                    this.updated = false;
                    this.starRating = 0;
                }, 2000);
                this.$store.commit('updateBulkRatings', this.starRating);
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import 'src/assets/scss/all.scss';
.stepperButtonWrapper {
    display: inline-block;
    margin-bottom: 20px;
    .title {
        color: $LCPMarine;
        font-size: 18px;
        font-weight: 700;
    }
    .icon {
        color: $midGrey;
        font-size: 22px;
        line-height: 30px;
        position: absolute;
        text-align: center;
        width: 20px;
    }
    .rating {
    font-size: 22px;
    margin: 0 10px;
    text-align: center;
    }
}
.stepperButton {
    background:$LCPWatermelon;
    border-radius: 6px;
    color: white;
    cursor: pointer;
    display: inline-block;
    margin: 0px;
    padding: 10px 20px;
    position: relative;
    text-align: center;
    user-select: none;
    vertical-align: middle;
}
.confirmRatings {
    background:$LCPWatermelon;
    border-radius: 6px;
    color: white;
    cursor: pointer;
    display: block;
    margin-top: 10px;
    padding: 10px 20px;
    position: relative;
    text-align: center;
    user-select: none;
    .icon {
        color: #FFF;
        font-size: 16px;
        line-height: unset;
        position: unset;
        text-align: unset;
        vertical-align: middle;
        width: 26px;
    }
    &.disabled {
        background-color: lightgray;
        cursor: not-allowed;
    }
    &.updated {
        background-color: $LCPAquamarine;
    }
}
@media (max-width: 1536px) {
    .stepperButtonWrapper {
        margin-bottom: 10px;
    }
}
</style>
